import { Col, Form, Input, Row, Select } from "antd";
import { useOrganizationTypes } from "@/modules/organization-types/hooks/useOrganizationTypes";
import { usePositionsStore } from "../store/positions.store";
import type { CreateOrganizationTypePositionRequest } from "../types";

interface PositionFormProps {
	form: ReturnType<typeof Form.useForm<CreateOrganizationTypePositionRequest>>[0];
}

export function PositionForm({ form }: PositionFormProps) {
	const editingItem = usePositionsStore((s) => s.editingItem);
	const { data: orgTypesData, isLoading: orgTypesLoading } = useOrganizationTypes({
		page: 1,
		limit: 10,
	});

	return (
		<Form form={form} layout="vertical" requiredMark={false}>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item
						name="name"
						label="Nomi"
						rules={[
							{ required: true, message: "Nomini kiriting" },
							{ max: 255, message: "Maksimum 255 ta belgi" },
						]}
					>
						<Input placeholder="Masalan: O'qituvchi" id="position-name" />
					</Form.Item>
				</Col>
				{!editingItem && (
					<Col span={12}>
						<Form.Item
							name="typeId"
							label="Tashkilot turi"
							rules={[{ required: true, message: "Tashkilot turini tanlang" }]}
						>
							<Select
								placeholder="Tanlang"
								loading={orgTypesLoading}
								id="position-type"
								options={orgTypesData?.data?.items?.map((t) => ({
									value: t.id,
									label: t.name,
								}))}
								showSearch
								filterOption={(input, option) =>
									(option?.label as string)?.toLowerCase().includes(input.toLowerCase())
								}
							/>
						</Form.Item>
					</Col>
				)}
			</Row>
		</Form>
	);
}
